import * as URL         from 'url';
import React            from 'react';
import StandaloneButton from '../components/standalone_button';


export default function ServiceMonster({ status, onDisconnect }) {
  const connectURL = getConnectURL();

  switch (status) {
    case null:
    case undefined:
    case 404:
      return <Connect connectURL={connectURL}/>;
    case 200:
      return <Connected onDisconnect={onDisconnect}/>;
    default:
      return <Error connectURL={connectURL}/>;
  }
}


export function Connect({ connectURL }) {
  return (
    <div className="list">
      <p className="block inset">
        Once you add ServiceMonster, created invoices will appear
        in the Broadly App as new customers, and we will follow up with your
        customers.
      </p>
      <StandaloneButton href={connectURL} label="Add ServiceMonster" external/>
    </div>
  );
}


export function Connected({ onDisconnect }) {
  return (
    <div className="list">
      <p className="block inset">
        ServiceMonster is working as expected and sending us data.
      </p>
      <StandaloneButton label="Stop Using ServiceMonster" onClick={onDisconnect} danger/>
    </div>
  );
}


export function Error({ connectURL }) {
  return (
    <div className="list">
      <p className="block inset">
        Something is wrong with your ServiceMonster data source.
        Usually this is resolved by connecting it again.
      </p>
      <StandaloneButton href={connectURL} label="Add ServiceMonster" external/>
    </div>
  );
}


function getConnectURL() {
  const connectURL = URL.format({
    protocol: 'https',
    hostname: 'six.servicemonster.net',
    pathname: '/desktop',
    hash:     'marketplace/item/f7be6af9-3441-11e8-8c1a-fec578518208'
  });

  return connectURL;
}
